import React from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  return <section className="py-20 bg-[#FFF8F0]" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="max-w-5xl mx-auto" data-id="element-3">
          <div className="text-center mb-16" data-id="element-4">
            <motion.div initial={{
            scale: 0.9,
            opacity: 0
          }} whileInView={{
            scale: 1,
            opacity: 1
          }} viewport={{
            once: true
          }} className="inline-block bg-pink-600 text-white px-6 py-2 rounded-full font-bold text-lg mb-6 shadow-lg transform -rotate-2" data-id="element-5">
              🎁 BONOS GRATIS — Solo Por Hoy
            </motion.div>
            <h2 className="text-3xl md:text-4xl font-bold text-purple-900 font-serif" data-id="element-6">
              Lleva estas herramientas exclusivas sin costo adicional
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-7">
            {/* Bonus 1 */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="flex flex-col items-center group" data-id="element-8">
              <div className="relative w-full max-w-sm mx-auto mb-6" data-id="element-9">
                <div className="absolute -inset-4 bg-gradient-to-r from-pink-200 to-purple-200 rounded-2xl blur-xl opacity-50 group-hover:opacity-70 transition duration-500" data-id="element-10"></div>
                <div className="absolute top-4 -right-4 bg-amber-500 text-white font-bold px-4 py-1 rounded-full z-20 shadow-lg transform rotate-12" data-id="element-11">
                  GRATIS
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/3nYKTcdqXD5K3hn5kDpC9j/BONO_1.png" alt="Bono 1: Kit Antiansiedad Día 3" className="relative z-10 w-full h-auto rounded-xl shadow-2xl transform transition-transform group-hover:scale-105 duration-500" data-id="element-12" />
              </div>
              <h3 className="text-2xl font-bold text-purple-900 text-center" data-id="element-13">
                Bono 1: Kit Antiansiedad Día 3
              </h3>
            </motion.div>

            {/* Bonus 2 */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="flex flex-col items-center group" data-id="element-14">
              <div className="relative w-full max-w-sm mx-auto mb-6" data-id="element-15">
                <div className="absolute -inset-4 bg-gradient-to-r from-purple-200 to-amber-200 rounded-2xl blur-xl opacity-50 group-hover:opacity-70 transition duration-500" data-id="element-16"></div>
                <div className="absolute top-4 -right-4 bg-amber-500 text-white font-bold px-4 py-1 rounded-full z-20 shadow-lg transform rotate-12" data-id="element-17">
                  GRATIS
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/8sMscoxwdc6W4tBE2iqmWs/BONO_2.png" alt="Bono 2: Plantillas Express en 5 Minutos" className="relative z-10 w-full h-auto rounded-xl shadow-2xl transform transition-transform group-hover:scale-105 duration-500" data-id="element-18" />
              </div>
              <h3 className="text-2xl font-bold text-purple-900 text-center" data-id="element-19">
                Bono 2: Plantillas Express en 5 Minutos
              </h3>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}